{
  "appName": "VynaEMR",
  "appTagline": "亞太優先電子病歷系統",
  "developedByLabel": "開發",
  "loading": "載入中...",
  "save": "儲存",
  "cancel": "取消",
  "delete": "刪除",
  "edit": "編輯",
  "create": "新增",
  "search": "搜尋",
  "filter": "篩選",
  "actions": "操作",
  "confirm": "確認",
  "back": "返回",
  "next": "下一步",
  "previous": "上一步",
  "submit": "提交",
  "reset": "重設",
  "close": "關閉",
  "yes": "是",
  "no": "否",
  "ok": "確定",
  "error": "錯誤",
  "success": "成功",
  "warning": "警告",
  "info": "提示",
  "validation": {
    "required": "此欄位為必填",
    "invalidEmail": "電郵格式不正確",
    "invalidPhone": "電話號碼格式不正確",
    "invalidDate": "日期格式不正確",
    "minLength": "最少需要 {{min}} 個字元",
    "maxLength": "最多允許 {{max}} 個字元",
    "passwordMismatch": "兩次輸入的密碼不一致"
  },
  "form": {
    "fieldRequired": "請填寫{{field}}",
    "selectOption": "請選擇一項",
    "discardConfirm": "放棄未儲存嘅變更？",
    "unsavedChanges": "您有未儲存嘅變更",
    "mustBeNonNegativeInteger": "{{field}}必須為不小於 0 的整數",
    "mustBeNonNegativeNumber": "{{field}}必須為不小於 0 的數字"
  },
  "unsavedChanges": {
    "title": "未儲存的變更",
    "body": "您有未儲存的變更。確定要離開此頁面嗎?所作變更將會遺失。",
    "stay": "留在本頁",
    "leave": "離開"
  },
  "messages": {
    "saveSuccess": "儲存成功",
    "saveError": "儲存失敗",
    "deleteConfirm": "確定要刪除此項目嗎？",
    "deleteSuccess": "刪除成功",
    "deleteError": "刪除失敗",
    "networkError": "網絡錯誤，請檢查網絡連線。",
    "serverError": "伺服器錯誤，請稍後再試。",
    "unauthorized": "您無權執行此操作。"
  },
  "dateFormat": {
    "short": "YYYY/MM/DD",
    "long": "YYYY年M月D日",
    "withTime": "YYYY/MM/DD HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "這是 VynaEMR 示範環境 — 請勿輸入真實患者資訊（PHI）。"
  },
  "network": {
    "offline": "您目前離線。臨床資料可能無法儲存。"
  },
  "permissionDenied": {
    "title": "存取被拒",
    "body": "您沒有權限{{action}}。",
    "genericBody": "您沒有權限查看此資源。",
    "requiredPermission": "所需權限：{{name}}",
    "contactAdmin": "如果您認為這是錯誤，請聯絡您的系統管理員。",
    "requiresPermissionCode": "需要權限：{{code}}",
    "requiresLabel": "需要 {{label}}",
    "requiresLabelWithRoles": "需要 {{label}}（持有者：{{roles}}）",
    "insufficient": "權限不足"
  },
  "skipToContent": "跳至主要內容",
  "openMenu": "開啟選單",
  "topBar": {
    "searchPlaceholder": "搜尋患者（MRN、姓名、ID）...",
    "recentPatients": "最近患者",
    "searching": "搜尋中...",
    "noPatientsFound": "找不到患者。按 Enter 鍵搜尋。",
    "notifications": "通知",
    "selectFacility": "選擇機構",
    "allFacilities": "所有機構",
    "facilityLabel": "機構 {{id}}",
    "activeDepartment": "當前科室",
    "selectDepartment": "選擇工作科室",
    "noDepartmentSelected": "請選擇科室",
    "departmentLabel": "科室 {{id}}",
    "departmentSwitchFailed": "切換失敗"
  },
  "theme": {
    "toggle": "切換主題",
    "light": "淺色",
    "dark": "深色",
    "system": "系統",
    "current": "主題：{{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "運行正常",
  "footerHealthIssue": "連線異常",
  "dobLabel": "出生日期 {{date}}",
  "pagination": {
    "previous": "上一頁",
    "next": "下一頁",
    "pageOf": "第 {{current}} 頁，共 {{total}} 頁",
    "showing": "顯示第 {{from}} 至 {{to}} 項，共 {{total}} 項",
    "loadMore": "載入更多"
  },
  "table": {
    "empty": "沒有資料",
    "loading": "載入中..."
  },
  "cdsAlert": {
    "severity": {
      "info": "資訊",
      "warning": "警告",
      "critical": "嚴重"
    },
    "overridden": "已覆寫",
    "acknowledged": "已確認",
    "justificationPlaceholder": "請輸入理由說明...",
    "submit": "提交",
    "acknowledge": "確認",
    "override": "覆寫",
    "regionAria": "臨床決策支援（CDS）警報",
    "acknowledgeFailed": "無法記錄確認 — 未儲存。請重試。",
    "overrideFailed": "無法記錄覆寫 — 未儲存。請重試。",
    "addressedCount_one": "已處理 {{count}} 項",
    "addressedCount_other": "已處理 {{count}} 項"
  },
  "components": {
    "printButton": {
      "defaultLabel": "列印"
    },
    "codeSearch": {
      "searchPlaceholder": "搜尋代碼...",
      "clearAriaLabel": "清除選擇",
      "noCodesFound": "找不到代碼"
    },
    "demographicPicker": {
      "addPlaceholder": "新增…",
      "loading": "載入中…",
      "noneRecorded": "未記錄",
      "removeAriaLabel": "刪除{{value}}",
      "unavailable": "值清單無法使用",
      "unavailableHint": "無法載入值清單。現有值保持不變，仍會儲存。",
      "uncodedBadge": "未編碼",
      "uncodedTitle": "於啟用編碼值之前記錄。可以刪除，但無法重新新增。"
    }
  },
  "pages": {
    "accessDenied": {
      "title": "拒絕存取",
      "httpStatus": "HTTP 403",
      "body": "您沒有權限檢視此頁面。",
      "attemptedLabel": "嘗試存取：",
      "requiredPermissionLabel": "所需權限：",
      "typicallyHeldByLabel": "通常擁有此權限的角色：",
      "signedInAs": "登入使用者：",
      "contactAdminHelp": "如您認為這是錯誤，請聯絡系統管理員或部門主管以申請所需角色。",
      "goBack": "返回",
      "dashboard": "儀表板",
      "contact": "聯絡"
    },
    "notificationInbox": {
      "title": "通知",
      "markAllRead": "全部標記為已讀",
      "loading": "正在載入通知…",
      "errorState": "通知載入失敗。",
      "emptyState": "未找到通知。",
      "ariaFilterStatus": "按狀態篩選",
      "ariaFilterPriority": "按優先程度篩選",
      "ariaFilterType": "按類型篩選",
      "filterStatus": {
        "all": "全部",
        "unread": "未讀",
        "read": "已讀"
      },
      "filterPriority": {
        "allLabel": "全部優先程度",
        "critical": "危急",
        "high": "高",
        "normal": "一般",
        "low": "低"
      },
      "filterType": {
        "allLabel": "全部類型"
      },
      "notificationType": {
        "criticalResult": "危急值結果",
        "orderUpdate": "醫囑更新",
        "appointmentReminder": "預約提醒",
        "systemAlert": "系統提示",
        "cdsAlert": "臨床決策提示",
        "result": "檢驗結果",
        "handoffAssigned": "交接"
      },
      "toasts": {
        "allMarkedRead": "所有通知已標記為已讀",
        "markAllReadFailed": "全部標記為已讀失敗",
        "markReadFailed": "通知標記為已讀失敗"
      }
    },
    "entityResolver": {
      "invalidId": "連結無效。",
      "notFound": "找不到，或您無權存取。"
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "即時更新無法使用",
    "body": "在連線恢復之前，新的結果和提醒將不會自動送達。",
    "authBody": "您的工作階段已逾時。請重新登入以恢復即時更新。",
    "retry": "重試",
    "login": "登入"
  }
}
